import React, { useEffect, useRef } from 'react';
import './About.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { Autoplay, Navigation, Pagination, Scrollbar } from 'swiper/modules';

function About_en() {
  const leftSectionRef = useRef(null);
  const rightSectionRef = useRef(null);
  const logoRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add(entry.target.dataset.animation);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
  
    const leftSection = leftSectionRef.current;
    const rightSection = rightSectionRef.current;
    const logo = logoRef.current;
  
    if (leftSection) {
      leftSection.classList.add('hidden');
      leftSection.dataset.animation = 'fade-in-right';
      observer.observe(leftSection);
    }
  
    if (rightSection) {
      rightSection.classList.add('hidden');
      rightSection.dataset.animation = 'fade-in-left';
      observer.observe(rightSection);
    }
  
    if (logo) {
      logo.classList.add('hidden');
      logo.dataset.animation = 'fade-in-top';
      observer.observe(logo);
    }
  
    return () => {
      if (leftSection) observer.unobserve(leftSection);
      if (rightSection) observer.unobserve(rightSection);
      if (logo) observer.unobserve(logo);
    };
  }, []);
  

  return (
    <div className="About" id="About" >
      <div className='About-Body'>
        
        <div className="About-content">

          <section className="left-section-en" ref={leftSectionRef}>
            <div className="img-wrapper">
              <Swiper
                spaceBetween={50}
                slidesPerView={1}
                navigation
                autoplay={{
                  delay: 3500, // 3 seconds delay between slides
                  disableOnInteraction: false,
                }}
                modules={[Autoplay, Navigation, Pagination, Scrollbar]} // Include required modules
              >
                <SwiperSlide>
                  <img className='About-pic' src={require('../../../Assets/Images/Ai.jpg')} alt="AI Illustration 1" />
                </SwiperSlide>
                <SwiperSlide>
                  <img className='About-pic' src={require('../../../Assets/Images/development.jpg')} alt="AI Illustration 2" />
                </SwiperSlide>
                <SwiperSlide>
                  <img className='About-pic' src={require('../../../Assets/Images/project-management-about.jpg')} alt="AI Illustration 3" />
                </SwiperSlide>
              </Swiper>
            </div>
          </section>
          <section className="right-section-en" ref={rightSectionRef}>
            <h2> We are here to offer you the best modern technical solutions </h2>
            <p> We are a specialized IT team offering innovative solutions using artificial intelligence to improve business performance and increase productivity. <br/><br/> Our services include process automation, daily task monitoring, and e-commerce solutions. We work in fields such as medicine, management, banking, and education. We use advanced systems to collect and analyze data and produce reports that support continuous development. </p>
            <div className="button-container">
              <a href="#Services">
                <button alt='#Services'> Learn About Us </button>
              </a>
            </div>
          </section>
          
          
        </div>
        <svg className="wave" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path fill="#ffffff" fillOpacity="0.1" d="M0,256L48,229.3C96,203,192,149,288,138.7C384,128,480,160,576,165.3C672,171,768,149,864,144C960,139,1056,149,1152,165.3C1248,181,1344,203,1392,213.3L1440,224L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"></path>
        </svg>
      </div>
    </div>
  );
}

export default About_en;
